// extracted by mini-css-extract-plugin
export default {"axis-tick":"uoOFrtu___axis-tick","axisTick":"uoOFrtu___axis-tick","day-off":"VHSrnvx___day-off","dayOff":"VHSrnvx___day-off"};